module.exports = __webpack_public_path__ + "img/minus-solid.685eee05.svg";